import { DataServiceBase } from "../../DataServiceBase";

(function ($, ko) {
    class SpecialtyService extends DataServiceBase {
        constructor() {
            super('/SmartAccount/Vendors/FindCare');
        }

        searchAsync(page, pageSize, search) {
            let urlParams = {
                Page: page,
                PageSize: pageSize,
                Search: search,
            }
            return this.getAsync(urlParams, 'Specialist');
        }

    }

    $.extend(true, $.cdh, {
        http: {
            smartAccount: {
                vendors: {
                    SpecialtyService : SpecialtyService
                }
            }
        }
    });
})(jQuery, ko);